export function classNames(baseClass, ...rest) {
  return `${baseClass} ${[...rest].join(' ')}`;
}
